/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Stock_Check_ButtonInputs */

const vi_await_stock_check_button = /** @type {(inputs: Await_Stock_Check_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm tra đủ hàng`)
};

/**

* @param {Await_Stock_Check_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_stock_check_button = /** @type {((inputs?: Await_Stock_Check_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Stock_Check_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_stock_check_button(inputs)
});